import React, {  useEffect, useState} from "react";
import { Link } from "react-router-dom";
import apiClient from '../../../../../../services/apiClient';



export default function PaymentMethods() {

  const [paypalid, setpaypalid] = useState();
  const [stripid, setstripid] = useState();

  useEffect(() => {

    const fetchuserdata = async () => {
      try {
        const response = await apiClient.get(`/userdetaila/${JSON.parse(localStorage.getItem('user')).user.id}`);
        setpaypalid(response.data.usersdetails[0].paypal_id);
        setstripid(response.data.usersdetails[0].stripe_id);
    
      } catch (error) {
        console.error('Error fetching contract:', error);
      }
    };
    fetchuserdata();
    
    }, []);



  const handlePayPalAuth = () => {
    const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID;
  const redirectUri = encodeURIComponent(`${process.env.REACT_APP_URL}/company-setting/paypalcallback`); // Ensure it's URL-encoded
  const paypalAuthUrl = `https://www.paypal.com/signin/authorize?client_id=${PAYPAL_CLIENT_ID}&response_type=code&redirect_uri=${redirectUri}`;

    // Redirect the user to PayPal for authorization
    window.location.href = paypalAuthUrl;
  };


  const handlestripeAuth = () => {
    const CLIENT_ID = process.env.REACT_APP_STRIPE_CLIENT_ID;
  const redirectUri = encodeURIComponent(`${process.env.REACT_APP_URL}/company-setting/my-company`); // Ensure it's URL-encoded
  const stripeAuthUrl = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=${CLIENT_ID}&scope=read_write&redirect_uri=${redirectUri}`;

    // Redirect the user to PayPal for authorization
     window.location.href = stripeAuthUrl;
  };



  


  useEffect(() => {
    // Extract the authorization code from the URL
    const queryParams = new URLSearchParams(window.location.search);
    const authorizationCode = queryParams.get('code');
  
    if (authorizationCode) {
     // alert(JSON.parse(localStorage.getItem('user')).user.id);
        // Exchange the authorization code for an access token
        exchangeCodeForToken(authorizationCode);
    }
  }, []);



  
  const exchangeCodeForToken = async (code) => {
    try {

      
        const response = await apiClient.post(`/exchange-code`, {
          code: code,user_id: JSON.parse(localStorage.getItem('user')).user.id,});
        const { connected_account_id } = response.data;
        // Handle the connected_account_id (e.g., store it in the database)
    } catch (error) {
        console.error('Error exchanging code for token:', error);
    }
  };


  return (
    <>
      <div className='tab-pane fade' id='content3'>
        {/*=============== Start: Payment Sections Start =============== */}
        <div className='row g-lg-5 g-md-5 g-3 mt-3'>
          {/*=============== Start: Payment Section-1 =============== */}
          <div className='mb-3 row col-md-12 gap-4  rounded '>
            
            <div className='payment-gate-way col-md-5 col-lg-5 '>
              <div className='w-100 text-center image'>
                <img src='/img/stripe.png' alt='stripe' className='stripe' />
              </div>
              <div className='payment-gate-way-footer btn d-flex justify-content-between' style={stripid?{backgroundColor: '#5ae546'}:{}}>
              {stripid ? (
                        <span className='d-sm-inline-block text-start' >
                          Connected
                        </span>
                      ) : (
                        <span className='d-sm-inline-block text-start' onClick={handlestripeAuth}>
                          Connect
                        </span>
                      )}

                
                <span className='d-md-inline-block text-end credit'>
                  Credit Cards
                </span>
              </div>
            </div>
            <div className='payment-gate-way col-md-5 col-lg-5 ' style={{ opacity: 0.5, pointerEvents: 'none' }}>
              <div className='w-100 text-center image'>
                {" "}
                <img src='/img/paypal.png' alt='paypal' className='paypal' />
              </div>

              <div className='payment-gate-way-footer btn d-flex justify-content-between'>
                <span className='d-sm-inline-block text-start'>
                  Coming Soon
                </span>
                
                <span className='d-md-inline-block text-end credit' >
                  Credit Cards
                </span>
              </div>
            </div>
          </div>
          {/*=============== End: Payment Section-1 =============== */}

          {/*=============== Start: Payment Section-2 =============== */}
          <div className='mb-3 col-md-12 border bg-white product-body rounded p-lg-3 p-md-2 p-2 my-4'>
            <div className='mb-3 col-md-6 my-5'>
              <h5 className='bold'>Client Payment Methods </h5>
            </div>

            <div className='table-responsive'>
              <table className='table'>
                <thead>
                  <tr>
                    <th></th>
                    <th>Payment Method </th>
                    <th>Connected To</th>
                    
                    <th></th>
                  </tr>
                </thead>
                <tbody>

                  {paypalid &&(<>
                    <tr>
                    <th scope='row'>
                      <i className='fa-solid fa-bars'></i>
                    </th>
                    <td>Paypal</td>
                    <td>{paypalid}</td>
                    
                    <td>
                      <Link
                        className='btn btn-primary btn-sm m-1'
                        to='#'
                        role='button'>
                        delete{" "}
                      </Link>
                    </td>
                  </tr>
                  
                  </>)}

                  {stripid &&(<>
                    <tr>
                    <th scope='row'>
                      <i className='fa-solid fa-bars'></i>
                    </th>
                    <td>Stripe</td>
                    <td>{stripid}</td>
                    
                    <td>
                      <Link
                        className='btn btn-primary btn-sm m-1'
                        to='#'
                        role='button'>
                        delete{" "}
                      </Link>
                    </td>
                  </tr>
                  
                  </>)}
                 
                </tbody>
              </table>
            </div>
          </div>
          {/*=============== End: Payment Section-2 =============== */}
        </div>
        {/*=============== End: Payment Sections Start =============== */}
      </div>
    </>
  );
}
